import { gql } from '@apollo/client';

export const GET_PRODUCT_LIST = () => gql`
  query GetProducts(
    $filters: [FilterInput]
    $sort: Sort
    $page: Int
    $limit: Int
    $search: String
    $excelDownload: String
    $excelFields: [String]
    $showAllProducts: Boolean
    $brand: String
    $showImportedProducts: Boolean
  ) {
    listAllProducts(
      filters: $filters
      limit: $limit
      sort: $sort
      page: $page
      search: $search
      showAllProducts: $showAllProducts
      brand: $brand
      showImportedProducts: $showImportedProducts
    ) {
      _id
      media_gallery {
        value
        position
      }
      fields
      inventory {
        country
        qty
      }
      approvalStatus
      selectedPrice {
        specialPrice
        currency
        country
        offerPeriod {
          startDate
          endDate
        }
      }
      defaultPrice {
        specialPrice
        currency
        country
      }
      selectedInventory
      actualStatus
      partnerSku {
        sku
        barcode
        costs {
          country
          cost
        }
      }
      inventory_updated_at
    }
    listAllProductsCount(
      filters: $filters
      limit: $limit
      search: $search
      excelDownload: $excelDownload
      excelFields: $excelFields
      showAllProducts: $showAllProducts
      brand: $brand
      showImportedProducts: $showImportedProducts
    ) {
      totalPages
      totalItems
      totalSuppressedItems
      random
      excelLink
    }
  }
`;

export const GET_PRODUCT_COUNT = () => gql`
  query GetProductsCount($filters: [FilterInput]) {
    listAllProductsCount(filters: $filters) {
      totalItems
    }
  }
`;

export const GET_PRODUCT_STATUS_COUNT = () => gql`
  query GetProductStatusCount($seller: String, $country: String) {
    getProductStatusCount(seller: $seller, country: $country) {
      status
      totalItems
    }
  }
`;
